import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AlertDialogService } from "./../../components/_alert-dialog/alert-dialog.service";
import { GroupeDialogService } from "./groupe-dialog.service";
import { Groupe } from "../../interfaces/Groupe";

@Component({
  selector: "groupe-dialog",
  templateUrl: "groupe-dialog.html",
  standalone: false,
})
export class GroupeDialogComponent implements OnInit {
  groupe: Groupe;
  isLoading: boolean = false;

  constructor(
    public _dr: MatDialogRef<GroupeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public groupe_ID: number,
    public _s: GroupeDialogService,
    private _alert: AlertDialogService
  ) {}

  ngOnInit(): void {
    this.getGroupe();
  }

  getGroupe(): void {
    this.isLoading = true;
    if (this.groupe_ID === 0) {
      this.groupe = {
        groupe_ID: 0,
        groupe_Code: null,
        groupe_Libelle: null,
      };
      this.isLoading = false;
    } else {
      this._s.get(this.groupe_ID, (groupe: Groupe) => {
        this.groupe = groupe;
        this.isLoading = false;
      });
    }
  }

  postGroupe(): void {
    this.isLoading = true;
    this._s.post(this.groupe, (groupe: Groupe) => {
      this.groupe = groupe;
      this.isLoading = false;
      this._dr.close(true);
    });
  }

  deleteGroupe(): void {
    this._alert.openConfirm(
      "Voulez-vous vraiment supprimer ce groupe ?",
      () => {
        this.isLoading = true;
        this._s.delete(this.groupe.groupe_ID, () => {
          this.isLoading = false;
          this._dr.close(true);
        });
      }
    );
  }

  close(): void {
    this._dr.close(false);
  }
}
